import React, { useState } from 'react';
// material
import { Card, Stack, Container, Typography, Modal, CircularProgress, Box, Link } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
// components
import { useTheme } from '@material-ui/core/styles';
import Page from '../../components/Page';
import { MHidden } from '../../components/@material-extend';
import { LoginForm } from '../../components/authentication/login';
import LoginAccessTag from '../../components/authentication/login/LoginAccessTag';
// ----------------------------------------------------------------------

export default function Login() {
  const theme = useTheme();
  const [showIframe, setShowIframe] = useState(false);
  const [loading, setLoading] = useState(true);

  const handleIframeLoad = () => {
    setLoading(false);
  };

  const handleCloseModal = () => {
    setShowIframe(false);
    setLoading(false);
  };

  return (
    <Page
      title="Login | HUB CREA EMPRESA"
      sx={{
        background: theme.palette.primary.main,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: { xs: 2, md: 0 }
      }}
    >
      <Modal open={showIframe} onClose={handleCloseModal}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%'
          }}
        >
          <Box
            sx={{
              minWidth: { xs: '90%', sm: '70%', md: '50%' },
              height: { xs: '85vh', md: '80vh' },
              bgcolor: '#fff',
              border: '1px solid #ccc',
              borderRadius: 3,
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              p: 2
            }}
          >
            <CloseIcon
              sx={{
                cursor: 'pointer',
                position: 'absolute',
                top: 8,
                right: 8,
                zIndex: 999
              }}
              onClick={handleCloseModal}
            />

            {loading && (
              <Box
                sx={{
                  position: 'absolute',
                  inset: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <CircularProgress />
              </Box>
            )}

            <iframe
              title="Formulário de contato"
              className="clickup-embed clickup-dynamic-height"
              src="https://forms.clickup.com/31075871/f/xmbgz-22663/L9OQVKOVN27X5MW60O"
              style={{
                maxWidth: '95%',
                maxHeight: '95%',
                width: '100%',
                height: '100%',
                border: '1px solid #ccc',
                background: 'transparent',
                visibility: loading ? 'hidden' : 'visible'
              }}
              onLoad={handleIframeLoad}
            />
          </Box>
        </Box>
      </Modal>

      <Container maxWidth="lg" sx={{ display: 'flex', justifyContent: 'center' }}>
        <Card
          sx={{
            width: { xs: '100%', sm: '90%', md: '70%' },
            borderRadius: '20px',
            overflow: 'hidden',
            boxShadow: 6
          }}
        >
          <Stack direction={{ xs: 'column', md: 'row' }}>
            <MHidden width="mdDown">
              <Stack
                alignItems="center"
                justifyContent="center"
                sx={{
                  width: '50%',
                  p: 4
                }}
              >
                <Box
                  component="img"
                  src="/static/hub-crea/LOGO-HUB-CREA-FINAL-78.png"
                  alt="HUB CREA"
                  sx={{
                    width: '60%',
                    maxWidth: '25rem',
                    mb: 2
                  }}
                />
                <LoginAccessTag label="Acesso para empresa" />
              </Stack>
            </MHidden>

            <Stack
              sx={{
                width: { xs: '100%', md: '50%' },
                px: { xs: 3, sm: 5, md: 6 },
                py: { xs: 4, md: 6 }
              }}
            >
              <MHidden width="mdUp">
                <Stack alignItems="center" sx={{ mb: 1 }}>
                  <Box
                    component="img"
                    src="/static/hub-crea/LOGO-HUB-CREA-HORIZONTAL-FINAL-16.png"
                    alt="HUB CREA"
                    sx={{
                      width: '100%',
                      maxWidth: '14rem',
                      mb: 2.5
                    }}
                  />
                  <LoginAccessTag label="Acesso para empresa" sx={{ mt: 0 }} />
                </Stack>
              </MHidden>
              <Typography fontWeight="bold" variant="h4" color="primary.dark">
                Bem vindo(a)!
              </Typography>

              <Typography variant="h6" color="primary.dark" sx={{ mb: 3, mt: 2 }}>
                Entre com seu e-mail
              </Typography>

              <LoginForm />

              <Stack alignItems="center" sx={{ mt: 2 }}>
                <Typography variant="subtitle1" color="grey.600" fontSize={14}>
                  Ainda não tem uma conta?
                </Typography>
                <Link href="/auth/register" style={{ textDecoration: 'none' }}>
                  <Typography variant="h6" color="primary">
                    Cadastre-se
                  </Typography>
                </Link>
              </Stack>
            </Stack>
          </Stack>
        </Card>
      </Container>
    </Page>
  );
}
